import { ApolloError } from '@apollo/client';

import { DUPLICATE_TITLE_ERROR_MESSAGE } from '../ui/PromoRollSynthModal/consts';

export const isDuplicateTitleError = (error: unknown): boolean =>
  error instanceof ApolloError && error.message.includes(DUPLICATE_TITLE_ERROR_MESSAGE);
